"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbsenceTypeModalBody = AbsenceTypeModalBody;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const FormContext_1 = require("../../../View/Modals/FormContext");
const GenericComponents_1 = require("../../../View/Modals/CommonFormComponents/GenericComponents");
const absenceTypePool_1 = require("../absenceTypePool");
function AbsenceTypeModalBody({ isEditing, initialData }) {
    const { register, reset, setValue, watch, formState: { errors }, trigger, } = (0, FormContext_1.useFormContext)();
    (0, react_1.useEffect)(() => {
        const resetData = {
            name: initialData?.name ?? "",
            color: initialData?.color ?? "#0d6efd",
            countsAgainstLimit: initialData?.countsAgainstLimit ?? true,
            countsAsCare: initialData?.countsAsCare ?? false,
            countsAsHoliday: initialData?.countsAsHoliday ?? false,
            // Domyślnie WOLNO brać na godziny - tak samo, jak stoi kolumna w bazie
            // i jak zakłada walidator serwera przy braku pola w payloadzie.
            allowsPartialDay: initialData?.allowsPartialDay ?? true,
        };
        reset(resetData);
        trigger();
    }, [initialData, reset]);
    const usageCount = initialData?._usageCount ?? 0;
    const partialUsageCount = initialData?._partialUsageCount ?? 0;
    // Ostrzegamy dopiero wtedy, gdy zapis NAPRAWDĘ zostawi osierocone wpisy: przy edycji
    // istniejącego typu, ze zdjętą kratką i przy nieobecnościach godzinowych w historii.
    // Serwer nie kasuje ich ani nie przelicza - one po prostu przestają dawać się edytować.
    const warnAboutPartial = isEditing && !watch("allowsPartialDay") && partialUsageCount > 0;
    // Lista czyta i zapisuje te same trzy flagi co dotąd - zmienia się tylko sposób ich
    // wskazania. Payload zostaje bez zmian, backend nic o tym wyborze nie wie.
    const pool = (0, absenceTypePool_1.readPool)({
        countsAgainstLimit: watch("countsAgainstLimit"),
        countsAsCare: watch("countsAsCare"),
        countsAsHoliday: watch("countsAsHoliday"),
    });
    function selectPool(value) {
        const flags = (0, absenceTypePool_1.poolFlags)(value);
        setValue("countsAgainstLimit", flags.countsAgainstLimit);
        setValue("countsAsCare", flags.countsAsCare);
        setValue("countsAsHoliday", flags.countsAsHoliday);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 8, controlId: "name" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Nazwa"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "np. Wypoczynkowy", isInvalid: !!errors?.name, ...register("name") }),
                react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "name", errors: errors })),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 4, controlId: "color" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Kolor"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "color", title: "Wybierz kolor", ...register("color") }),
                react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "color", errors: errors }))),
        react_1.default.createElement("hr", null),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "pool" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Z kt\u00F3rej puli schodzi"),
            react_1.default.createElement(react_bootstrap_1.Form.Select, { value: pool, onChange: (e) => selectPool(e.target.value) }, absenceTypePool_1.ABSENCE_POOLS.map((option) => (react_1.default.createElement("option", { key: option.value, value: option.value }, option.label))))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "allowsPartialDay", className: "mt-3" },
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "checkbox", label: "Mo\u017Cna bra\u0107 na godziny (cz\u0119\u015B\u0107 dnia)", ...register("allowsPartialDay") }),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true, className: "d-block" }, "Zdj\u0119ta kratka znaczy, \u017Ce ten typ wpisuje si\u0119 wy\u0142\u0105cznie na ca\u0142e dni. Poza tym wyborem nic tego nie narzuca - system nie zna prawnych r\u00F3\u017Cnic mi\u0119dzy typami nieobecno\u015Bci."),
            warnAboutPartial && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "py-2 mt-2 mb-0" },
                "Ten typ ma ",
                react_1.default.createElement("strong", null, partialUsageCount),
                " ",
                partialUsageCount === 1
                    ? "nieobecność wpisaną"
                    : "nieobecności wpisanych",
                " ",
                "na godziny. Po zdj\u0119ciu kratki zostan\u0105 w kalendarzu i dalej b\u0119d\u0105 si\u0119 liczy\u0107 do puli, ale ",
                react_1.default.createElement("strong", null, "nie dadz\u0105 si\u0119 edytowa\u0107"),
                ", dop\u00F3ki kratki nie postawisz z powrotem."))),
        react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true, className: "d-block mt-2" },
            "To regu\u0142a, a nie opis - kod wylicza na tej podstawie, z kt\u00F3rej puli schodzi nieobecno\u015B\u0107. Pule s\u0105 roz\u0142\u0105czne, dlatego jest to wyb\u00F3r, a nie zestaw prze\u0142\u0105cznik\u00F3w.",
            isEditing && usageCount > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                " ",
                "Ten typ jest u\u017Cyty ",
                react_1.default.createElement("strong", null, usageCount),
                " raz(y), wi\u0119c zmiana przeliczy salda wstecz.")))));
}
